import clsDataTable from '@cls/clsDataTable'

export default clsDataTable;